import Vue from 'vue';

const vue = new Vue({});

export async function del(payload) {
  try {
    const res = await vue.$api().del(payload);
    return Promise.resolve(res);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function get(payload) {
  try {
    const res = await vue.$api().get(payload);
    return Promise.resolve(res);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function patch(payload) {
  try {
    const res = await vue.$api().patch(payload);
    return Promise.resolve(res);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function post(payload) {
  try {
    const res = await vue.$api().post(payload);
    return Promise.resolve(res);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function put(payload) {
  try {
    const res = await vue.$api().put(payload);
    return Promise.resolve(res);
  } catch (error) {
    return Promise.reject(error);
  }
}

export default {
  del,
  get,
  patch,
  post,
  put,
};
